import { OrderInvoiceStatus } from "../../ordering/enums/order-invoice-status";
import { AppliedFilterBarOpt, FilterBarInputOpt, FilterGroup, IFilterBar } from "../../utilities/filter-bar";
import { ListColumn, SelectedSort } from "../../utilities/list-header";
import { PageData } from "../../utilities/paged-request";
import { ApiEndpoints, GlobalConstants } from "../../../utils/app-constants";

/**
 * The orders that are billing only and are waiting to be invoiced
 */
export class BillingOnlySearchFilter implements IFilterBar {

    public paginationInfo   : PageData = new PageData(GlobalConstants.DEFAULT_PAGE_SIZE);
    public baseUrl          : string = ApiEndpoints.ORDERING_ORDER_QUERY;
    public filters          : FilterGroup[] = [];
    public appliedFilters   : AppliedFilterBarOpt[] = [];
    public requiredFilters  : AppliedFilterBarOpt[] = [];
    public columns          : ListColumn[];
    public selectedSort     : SelectedSort;

    constructor() {

        // Set our table columns
        this.columns = [
            new ListColumn('Order ID', ''),
            new ListColumn('Dealer', ''),
            new ListColumn('Quantity', ''),
            new ListColumn('Description', ''),
            new ListColumn('Job Name', ''),
            new ListColumn('Amount', ''),
            new ListColumn('Actions', '', false, 'table-cell-center')
        ];

        const readonlyLabel = this.buildReadonlyLabel();
        this.filters.push(readonlyLabel);

        // Create our Non-Optional Filters
        this.requiredFilters.push(this.buildBillingOnly());
        this.requiredFilters.push(this.buildInvoiceStatus());

    }

    private buildReadonlyLabel() {
        const byAssetName = new FilterGroup('Name', 'readonly', 'name');
        const opt1 = new FilterBarInputOpt('Billing Only Orders', '');

        byAssetName.opts = [opt1];

        return byAssetName;
    }

    private buildBillingOnly() {
        const requiredType      = new AppliedFilterBarOpt();
        requiredType.uuid       = '';
        requiredType.label      = 'Billing Only';
        requiredType.qsName     = 'isBillingOnly';
        requiredType.qsValue    = 'true';

        return requiredType;
    }

    private buildInvoiceStatus() {
        const requiredType      = new AppliedFilterBarOpt();
        requiredType.uuid       = '';
        requiredType.label      = 'Invoice Status';
        requiredType.qsName     = 'invoiceStatus';
        requiredType.qsValue    = `${ OrderInvoiceStatus.Open }`;

        return requiredType;
    }

}
